import VueSelect from './components/Select.vue'

export default VueSelect
